<template>
  <LoadOnVisible v-on:intersected="loadChartData">
    <b-card no-body>
      <b-card-header>
        <!-- title and subtitle -->
        <div>
          <b-card-title class="font-weight-bolder mb-1">
            Most Popular Products
          </b-card-title>
          <b-card-sub-title class="mb-25">
            based on number of shipped items
          </b-card-sub-title>
        </div>
        <!--/ title and subtitle -->

        <!-- datepicker -->
        <!-- <div class="d-flex align-items-center">
          <feather-icon icon="CalendarIcon" size="16" />
          <flat-pickr
            v-model="rangePicker"
            :config="{ mode: 'range' }"
            class="form-control flat-picker bg-transparent border-0 shadow-none"
            placeholder="YYYY-MM-DD"
          />
        </div> -->

        <span
          class="border badge badge-transparent d-none d-sm-inline-block"
          right
          no-caret
          toggle-class="p-0 mb-25"
          size="sm"
          >Last 7 Days
        </span>
        <!-- datepicker -->
      </b-card-header>

      <b-card-body>
        <div class="text-center" v-if="isLoadingChartData">
          <b-spinner
            variant="primary"
            class="m-5"
            style="height: 4rem; width: 4rem"
            label="Loading..."
          ></b-spinner>
        </div>
        <vue-apex-charts
          v-else
          ref="chart"
          type="bar"
          height="350"
          :options="chartData.chartOptions"
          :series="chartData.series"
        />
      </b-card-body>
    </b-card>
  </LoadOnVisible>
</template>

<script>
import { $themeColors } from '@/themeConfig';
import VueApexCharts from 'vue-apexcharts';
import { LoadOnVisible } from '@/views/components/custom';
export default {
  components: {
    VueApexCharts,
    LoadOnVisible
  },
  data() {
    let datFrom = this.flatPickrDateFormat();
    let datTo = this.flatPickrDateFormat(
      new Date(new Date().getTime() + 7 * 24 * 60 * 1000)
    );
    return {
      isLoadingChartData: true,
      chartData: {
        series: [
          {
            name: 'Sold',
            data: [700, 350, 480, 600, 210, 550, 150]
          }
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false
            }
          },
          colors: $themeColors.info,
          plotOptions: {
            bar: {
              horizontal: true,
              barHeight: '30%',
              endingShape: 'rounded'
            }
          },
          grid: {
            xaxis: {
              lines: {
                show: false
              }
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: [
              'MON, 11',
              'THU, 14',
              'FRI, 15',
              'MON, 18',
              'WED, 20',
              'FRI, 21',
              'MON, 23'
            ]
          },
          yaxis: {
            // opposite: isRtl,
          }
        }
      },
    };
  },
  created() {
    // subcomponent, do not call common data
  },
  computed: {
  },
  watch: {
    chartData: {
      handler: function(val) {
        // DOM updated
        if (this.$refs.chart) {
          this.$refs.chart.updateSeries(
            [
              {
                data: val.series[0].data
              }
            ],
            false,
            true
          );
          this.$refs.chart.updateOptions(
            {
              xaxis: val.chartOptions.xaxis
            },
            false,
            true
          );
        }
      },
      deep: true
    }
  },
  methods: {
    flatPickrDateFormat(yourDate = new Date()) {
      const offset = yourDate.getTimezoneOffset();
      yourDate = new Date(yourDate.getTime() - offset * 60 * 1000);
    },
    loadChartData() {
      this.isLoadingChartData = true;
      this.$http
        .post('/api/common/analytics/popular-products', {})
        .then(resp => {
          this.isLoadingChartData = false;
          let xAxisLabels = [];
          let dataPoints = [];
          let items = resp.data.items;
          items.forEach(itm => {
            dataPoints.push({ x: itm.sku, y: itm.quantity });
            xAxisLabels.push(itm.sku);
          });
          this.chartData.series[0].data = dataPoints;
          this.chartData.chartOptions.xaxis.categories = xAxisLabels;
        })
        .catch(err => {
          this.isLoadingChartData = false;
          console.log('this.chartData.series', this.chartData.series);
          this.chartData.series[0].data = [];
        });
    }
  },
  mounted() {
  }
};
</script>
